module.exports = __webpack_public_path__ + "static/media/sos-logo.7bb9c2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/ID/sos-logo.png
// module id = 1660
// module chunks = 0